'use client'

import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('Application error:', error)
  }, [error])

  return (
    <div className="flex h-screen flex-col items-center justify-center p-4 text-center">
      <h2 className="mb-2 text-2xl font-bold text-red-600">Something went wrong!</h2>
      <p className="mb-4 text-gray-600">
        We've encountered an error while loading the page.
      </p>
      <button
        onClick={() => reset()}
        className="rounded-lg bg-[#8A6FE8] px-4 py-2 text-white hover:bg-[#7B5BD6]"
      >
        Try again
      </button>
    </div>
  )
} 